import React from 'react';
import { useSelector } from 'react-redux';

import {
    performanceChartNavSelector,
    seasonSelector,
    roundSelector
} from 'store/modules/statspro/performance-chart/selectors';
import { getTranslation } from 'common/react/utils/translations';

import { STATS_CATEGORY_IDS } from 'widgets/statspro/js/components/common/config/performance-stats';

/**
 * @typedef {object} Props
 * @property {object} season
 * @property {object} round
 */

/**
 * @returns {JSX.Element} Loader or heading.
 */
export const Heading = () => {
    const nav = useSelector(performanceChartNavSelector);

    const season = useSelector(seasonSelector);
    const round = useSelector(roundSelector);

    // eslint-disable-next-line no-magic-numbers
    const seasonYear = season ? season.providerId.slice(4, 8) : '';
    const categoryId = [STATS_CATEGORY_IDS[nav.category]];

    return (
        <>
            <strong>
                {getTranslation('label.performanceChart.' + categoryId)}
            </strong>{' '}
            -{' '}
            {!season
                ? getTranslation('label.stats.career')
                : `${seasonYear} ${getTranslation('label.stats.season')} `}
            {round &&
                `(${getTranslation('label.match.round')} ${round.roundNumber})`}
        </>
    );
};
